import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Seo from "@/components/Seo";
import Header from "@/components/site/Header";
import Footer from "@/components/site/Footer";
import { ARTICLES } from "@/content/articles";

export default function ArticlesPage() {
  return (
    <>
      <Seo
        title="Articles - Plain-English Xero & Finance Guides | Clarus Partners"
        description="Plain-English guides on Xero, bookkeeping and cashflow for trades businesses, startups and service businesses - written by a CPA."
      />
      <Header />
      <main className="py-16 lg:py-24">
        <div data-testid="articles-page" className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <p className="text-sm font-bold uppercase tracking-widest text-terracotta">Articles</p>
          <h1 className="mt-3 text-3xl sm:text-4xl font-extrabold tracking-tight text-navy">
            Plain-English finance guides for small business
          </h1>
          <p className="mt-4 text-base text-navy/70 leading-relaxed max-w-2xl">
            Written by a CPA, for owners who'd rather be on the tools or building the business than reading accounting textbooks.
          </p>
          <div className="mt-12 space-y-6">
            {ARTICLES.map((a) => (
              <Link
                key={a.slug}
                to={`/articles/${a.slug}`}
                data-testid={`article-card-${a.slug}`}
                className="block rounded-2xl bg-white border border-border p-7 transition-all duration-300 hover:-translate-y-1 hover:shadow-lg group"
              >
                <p className="text-xs font-bold uppercase tracking-widest text-terracotta">{a.audience}</p>
                <h2 className="mt-2 text-xl sm:text-2xl font-bold text-navy group-hover:text-terracotta transition-colors">
                  {a.title}
                </h2>
                <p className="mt-2 text-sm text-navy/70 leading-relaxed">{a.description}</p>
                <p className="mt-4 inline-flex items-center gap-2 text-sm font-bold text-navy">
                  {a.readTime} <ArrowRight className="w-4 h-4 text-terracotta" aria-hidden="true" />
                </p>
              </Link>
            ))}
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}
